import { Close as CloseRoundedIcon } from "@material-ui/icons";
import { Menu as MenuOutlinedIcon } from "@material-ui/icons";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./CalendarHeader.css";

export default function CalendarHeader() {
  const [isMobile, setIsMobile] = useState(false);

  return (
    <div className="CalendarHeader">
      <nav className="navbar-calendar">
        <ul
          className={
            isMobile ? "nav-links-mobile-calendar" : "nav-links-calendar"
          }
          onClick={() => setIsMobile(false)}
        >
          <Link to="/" className="home-calendar">
            <li>Home</li>
          </Link>
          <Link to="/calendar" className="calendar-calendar">
            <li>Calendar</li>
          </Link>
          <Link to="/contact" className="contact-calendar">
            <li>Contact</li>
          </Link>
          <Link to="/donation" className="donation-calendar">
            <li>Donation</li>
          </Link>
        </ul>
        <button
          className="mobile-menu-icon-calendar"
          onClick={() => setIsMobile(!isMobile)}
        >
          {isMobile ? (
            <CloseRoundedIcon fontSize="large" />
          ) : (
            <MenuOutlinedIcon fontSize="large" />
          )}
        </button>
      </nav>
      <Link to="/">
        <div className="logo-calendar">
          <div className="logoItems">
            <img src="assets/logo.png" alt="" />
            <p>
              <strong>Claremont</strong> <br /> Main Road Mosque
            </p>
          </div>
        </div>
      </Link>
      <div className="centered">
        <div className="overlay-calendar">
          <h1>
            Claremont Main Road Mosque <br /> Calendar
          </h1>
        </div>
      </div>
    </div>
  );
}
